<template>

    <label class="skill_score_wrapper" :class="{isRefModel: isRefModel}">
        <slot></slot>
        <span class="score_label">
            <div class="score_number">{{scoreNumber}}</div>

            <div class="values_overlays" :class="numberValuesClass">

                <span class="first_custom_value"
                    :class="{active: secondCheck}">

                </span>
                <span class="second_custom_value"
                    :class="{active: thirdCheck}">
                </span>

            </div>

        </span>

    </label>

</template>

<script>
export default {
    name: 'SkillScoreRadioWrapper',
    props: {
        value: {},
        scoreNumber: { required: true, default: 1 },
        secondCheck: { default: false },
        thirdCheck: { default: false },
        isRefModel: { default: false }
    },
    data(){
        return {}
    },
    computed: {
        numberToDraw(){
            let numberValues = 0
            if(this.scoreNumber == this.value){ numberValues = numberValues + 1 }
            if(this.secondCheck){ numberValues = numberValues + 1 }
            if(this.thirdCheck){ numberValues = numberValues + 1 }
            return numberValues
        },
        isOneValue(){
            return this.secondCheck && !this.thirdCheck
        },
        isTwoValues(){
            return this.secondCheck && this.thirdCheck
        },
        numberValuesClass(){
            let classes = ""
            if(this.scoreNumber == this.value){
                classes = classes + "primary_score "
            }
            if(this.numberToDraw == 1){
                classes = classes + 'one_value'
            }else if(this.numberToDraw == 2){
                classes = classes + 'two_value'
            }else if(this.numberToDraw == 3){
                classes = classes + 'third_value'
            }else{
                classes = classes + 'no_value'
            }
            return classes
        }
    },
    methods: {

    }
}

</script>

<style lang="scss" >
.skill_score_wrapper {
    display: flex;
    position: relative;
    cursor: pointer;
    font-size: 22px;
    user-select: none;
    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    .score_label{
        z-index: 2;
        border-radius: 100%;
        height: $skill-score-radio-size;
        width: $skill-score-radio-size;
        line-height: $skill-score-radio-size;
        text-align: center;
        background-color: $grey-lighter;
        color: $white;
        font-size: 1.2rem;
        font-weight: 600;
        overflow: hidden;
        transition: .35s all;
        &.is_ideal{
            &:after {
              content: "";
              position: absolute;
              display: none;
              left: 9px;
              top: 5px;
              width: 5px;
              height: 10px;
            }
        }
        .score_number{
            position: relative;
            z-index: 5;
        }
        .values_overlays{
            border-radius: 100%;
            height: $skill-score-radio-size;
            width: $skill-score-radio-size;
            position: relative;
            margin-top: -$skill-score-radio-size;
            z-index: 1;
            &.one_value{
                &:not(.primary_score){
                    .first_custom_value, .second_custom_value{
                        width: 100%;
                    }
                }
            }
            &.two_value{
                &.primary_score{
                    .first_custom_value, .second_custom_value{
                        width: 50%;
                    }
                }
                &:not(.primary_score){
                    .first_custom_value{
                        width: 50%;
                        z-index: 4;
                    }
                    .second_custom_value{
                        width: 100%;
                        z-index: 3;
                    }
                }
            }
            &.third_value{
                .first_custom_value{
                    width: 33.333333333%;
                    z-index: 4;
                }
                .second_custom_value{
                    width: 66.666666666%;
                    z-index: 3;
                }
            }
            &.no_value{

            }
            .first_custom_value{
                transition: .3s all;
                width: 0%;
                position: absolute;
                height: $skill-score-radio-size;
                top:0;
                left: 0;
                z-index: 4;
                &.active{
                    transition: .3s all;
                    background-color: $second-score-color;
                    padding: $skill-score-padding-offset;
                }
            }
            .second_custom_value{
                transition: .3s all;
                width: 0%;
                position: absolute;
                height: $skill-score-radio-size;
                top:0;
                left: 0;
                z-index: 3;
                &.active{
                    transition: .3s all;
                    background-color: $third-score-color;
                    padding: $skill-score-padding-offset;
                }
            }
        }

    }
    &.isRefModel:before{
        z-index: 1;
        content: "";
        border-radius: 100%;
        position: absolute;
        height: $skill-score-border-size;
        width: $skill-score-border-size;
        line-height: $skill-score-border-size;
        top: $skill-score-offset;
        left: $skill-score-offset;
        border: 2px solid $primary;
    }
    &:hover input ~ .score_label {
      background-color: #ccc;
    }
    & input:checked ~ .score_label {
      background-color: $primary;
    }
    & input:checked ~ .score_label:after {
      display: block;
    }
}
</style>